module.exports = __webpack_public_path__ + "static/fonts/trebuchet_MS_Bold.ebcd048.woff2";